import * as React from 'react';
import CartShippingDetail from './CartShippingDetail';
import CartTools from './CartTools';

const CartRightContent = (props) => {
    return (
        <>
            <div className="col-xl-3 mb-4 cart-right-wrapper">
                <CartShippingDetail />
                <CartTools />
            </div>
        </>
    );
}

export default CartRightContent;